import { Body1, Button, Heading2, Stack } from '@phx/design-system';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getAbsoluteRoute } from '../../../util';

export const OutOfPocketOption = ({
    prescriptionId,
}: {
    prescriptionId: string;
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Stack>
            <Heading2>{t('priorAuthorization.outOfPocket.header')}</Heading2>
            <Body1>{t('priorAuthorization.outOfPocket.description')}</Body1>
            <Button
                variant="outline"
                onClick={() =>
                    navigate(
                        getAbsoluteRoute('cabinet.rxId.root', {
                            prescriptionId: prescriptionId,
                        })
                    )
                }
            >
                {t('priorAuthorization.outOfPocket.button')}
            </Button>
        </Stack>
    );
};
